A profile attachment stored at an external URL.
